"use strict";
exports.__esModule = true;
//# sourceMappingURL=heading2-slice.js.map